import axios from "axios"
import { authHeader } from "../../utils"
import { CREATE_TERM, CREATING_TERM, GET_TERMS, GETTING_TERMS, SET_SUCCESS, TERMS_ERROR, UPDATE_TERM, UPDATING_TERM } from "../types"


export const createTerm = (termPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_TERM,
            payload: true
        })
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/terms`, termPayload, { headers })
        
        dispatch({
            type: CREATE_TERM,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'New term created successfully for the current academic session'
        })
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: TERMS_ERROR,
            // payload: error.response.data
            error
        })
    }
}


export const clearCreatedTerm = () => async (dispatch) => {       
    dispatch({
        type: CREATE_TERM,
        payload: null
    })
}

export const fetchTerms= (filters, page, perPage, expand) => async dispatch => {    
    try{
        const headers = authHeader()

        let url = `${process.env.REACT_APP_BASE_URL}/terms`

        if(expand && expand !== ''){
            url += `${url.includes('?') ? '&' : '?'}${expand}`
        }

        if(filters && filters !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filters}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_TERMS,
            payload: true
        })

        const response = await axios.get(`${url}`, { headers })

        dispatch( {
            type: GET_TERMS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: TERMS_ERROR,
            // payload: error.response.data,
            error
        })
    }
}

export const clearOnboardedTerm = () => async dispatch => {
    dispatch({
        type: CREATE_TERM,
        payload: null
    })
}

export const updateTerm = (id, termPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_TERM,
            payload: true
        })
        const response = await axios.patch(`${process.env.REACT_APP_BASE_URL}/terms/${id}`, termPayload, { headers })
        
        dispatch({
            type: UPDATE_TERM,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Term updated successfully'
        })
        
    }
    catch(error){
        // console.log(error)
        dispatch({
            type: TERMS_ERROR,
            // payload: error.response.data
            error
        })
    }
}


export const clearUpdatedTerm = () => async (dispatch) => {       
    dispatch({
        type: UPDATE_TERM,
        payload: null
    })
}